import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { mapIndex } from 'utilities/ramda';

import { Paper, PaperTitle, Table } from 'virtues-bootstrap';
import PatientEngagementHeader from 'containers/PatientEngagement/PatientEngagementHeader';
import PatientEngagementRow from './Row';

import s from './styles.module.scss';

const PatientEngagement = ({ list, t }) => (
  <Paper>
    <PaperTitle withBorder>{t('patient.patientEngagement')}</PaperTitle>
    <div className={s.scrollTable}>
      <Table className={s.table} striped size="sm">
        <PatientEngagementHeader />
        <tbody>
          {mapIndex(
            ({ status, module, charter, feedback }, index) => (
              <PatientEngagementRow
                key={index}
                status={status}
                module={module}
                charter={charter}
                feedback={feedback}
              />
            ),
            list,
          )}
        </tbody>
      </Table>
    </div>
  </Paper>
);

PatientEngagement.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      module: PropTypes.string,
      charter: PropTypes.string,
      feedback: PropTypes.string,
    }),
  ).isRequired,
};

export default withTranslation()(PatientEngagement);
